import { render, staticRenderFns } from "./texts.vue?vue&type=template&id=ca24f972&scoped=true&"
import script from "./texts.vue?vue&type=script&lang=js&"
export * from "./texts.vue?vue&type=script&lang=js&"
import style0 from "./texts.vue?vue&type=style&index=0&id=ca24f972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24f972",
  null
  
)

export default component.exports